import { useTranslation } from 'react-i18next'
import './style.scss'
import { BackButton } from '@vkruglikov/react-telegram-web-app'
import { useState } from 'react'
import { useErrorBoundary } from 'react-error-boundary'
import useEnvInitData from '@/hooks/useEnvInitData'
import Alert from "@/components/Alert";
import SettingsApi from '@/features/Settings/api'
import { useParams } from 'react-router-dom'

export default function Members({ back }) {
	const { raffle_id } = useParams();
	const { t } = useTranslation()
	const [deleting, setDeleting] = useState(false);
	const { showBoundary } = useErrorBoundary()
	const [InitDataUnsafe, InitData] = useEnvInitData();
	const [alert, showAlert] = useState(false)
	const [deleteValue, setDeleteValue] = useState('')

	const handleDelete = () => {
		if (deleting || deleteValue.length < 5) return;
		setDeleting(true);

		SettingsApi.deleteUser({
			initData: InitData,
			raffle: raffle_id,
			value: deleteValue,
		}).then(function(result) {
			if (result.result) {
				showAlert(t('features.settings.shield.members.disallow.success'))
			} else {
				showAlert(t('features.settings.shield.members.disallow.failure'))
			}

			setTimeout(() => {
				showAlert(false)
			}, 3000)
		}).catch((e) => {
			showBoundary(e)
		}).finally(() => {
			setDeleting(false)
		})
	}

	const [restoring, setRestoring] = useState(false);
	const [restoreValue, setRestoreValue] = useState('')

	const handleRestore = () => {
		if (restoring || restoreValue.length < 5) return;
		setRestoring(true);

		SettingsApi.restoreUser({
			initData: InitData,
			raffle: raffle_id,
			value: restoreValue,
		}).then(function(result) {
			if (result.result) {
				showAlert(t('features.settings.shield.members.allow.success'))
			} else {
				showAlert(t('features.settings.shield.members.allow.failure'))
			}

			setTimeout(() => {
				showAlert(false)
			}, 3000)
		}).catch((e) => {
			showBoundary(e)
		}).finally(() => {
			setRestoring(false)
		})
	}

	return (
		<div className='Members'>
			<BackButton onClick={back} />
			<div className='boxText'>
				<div className='boxText_header'>{t('features.settings.shield.members.allow.title')}</div>
				<div className='boxText_body'>
					<p><b>{t('features.settings.shield.members.allow.text')}</b></p>

					<input type='text' className='input input--grey' placeholder={t('features.settings.shield.members.allow.placeholder')} value={restoreValue} onInput={(e) => setRestoreValue(e.target.value)} />

					<button className='btn btn--block' disabled={restoring || restoreValue.length < 5} type='button' onClick={handleRestore}>{t('features.settings.shield.members.allow.btn')}</button>
				</div>
			</div>
			<div className='boxText'>
				<div className='boxText_header'>{t('features.settings.shield.members.disallow.title')}</div>
				<div className='boxText_body'>
					<p><b>{t('features.settings.shield.members.disallow.text')}</b></p>

					<input type='text' className='input input--grey' placeholder={t('features.settings.shield.members.disallow.placeholder')} value={deleteValue} onInput={(e) => setDeleteValue(e.target.value)} />

					<button className='btn btn--block' disabled={deleting || deleteValue.length < 5} type='button' onClick={handleDelete}>{t('features.settings.shield.members.disallow.btn')}</button>
				</div>
			</div>
			{alert ? <Alert>{alert}</Alert> : null}
		</div>
	)
}
